/* Cuenta atras del aviso del carrito.
 *
 * Arranca en 8 minutos, baja hasta cero y entonces el contador DESAPARECE sin
 * hacer nada mas: no cambia precios, no vacia el carrito, no bloquea el pago.
 * Es urgencia visual, nada mas, y asi se pidio.
 *
 * Dos decisiones que importan:
 *
 * 1. El plazo se guarda en sessionStorage como una FECHA LIMITE, no como
 *    segundos restantes. Si guardaramos los segundos, el contador volveria a
 *    08:00 cada vez que el visitante cambia de pagina, y un contador que se
 *    reinicia solo se nota a la primera y deja en evidencia que es falso.
 *    Guardando el instante final, el tiempo corre de verdad durante la visita.
 *
 * 2. No guardamos una referencia al elemento: lo buscamos en cada tic. El
 *    renderContents de Dawn reemplaza entero el interior del cajon cada vez que
 *    se anade algo, destruyendo este <span> y creando otro. Con una referencia
 *    fija el contador se congelaria tras el primer anadido.
 */
(function () {
  var KEY = 'sdsCartDeadline';
  var MINUTOS = 8;
  var deadline = null;

  /* sessionStorage peta en modo privado de algunos navegadores: si falla,
     seguimos en memoria. Un contador sin memoria es peor que ninguno, pero
     mucho mejor que un error que tumbe el resto del script del carrito. */
  try {
    var guardado = parseInt(sessionStorage.getItem(KEY), 10);
    if (guardado) deadline = guardado;
  } catch (e) {}

  if (!deadline) {
    deadline = Date.now() + MINUTOS * 60 * 1000;
    try {
      sessionStorage.setItem(KEY, String(deadline));
    } catch (e) {}
  }

  var id = setInterval(tic, 250);
  tic();

  function tic() {
    var el = document.querySelector('[data-sds-timer]');
    if (!el) return; /* el cajon aun no esta en el DOM, o se esta re-render */

    var restante = deadline - Date.now();
    if (restante <= 0) {
      el.remove();
      clearInterval(id);
      return;
    }

    var seg = Math.floor(restante / 1000);
    var texto = ('0' + Math.floor(seg / 60)).slice(-2) + ':' + ('0' + (seg % 60)).slice(-2);
    if (el.textContent !== texto) el.textContent = texto;
    if (el.hidden) el.hidden = false;
  }
})();
